export default __webpack_public_path__ + "static/media/category-people.169ff78a.jpg";